import {useContext, useState} from "react";
import {useCreateMessageMutation} from "@ots-frontend/ots-data";
import {AuthContext} from "../app/AuthProvider";
import {CommentDialog} from "./CommentDialog";

export type EntityCommentTarget = {objectId: string; objectType: string; label?: string; tenantCode?: string};
export type EntityCommentDialogProps = {target: EntityCommentTarget; onClose: () => void; onCreated?: () => void};

/** One entity, one comment. Failed submissions keep the draft open; RTK invalidates the entity's comment cache. */
export function EntityCommentDialog({target, onClose, onCreated}: EntityCommentDialogProps) {
  const auth = useContext(AuthContext);
  const [createMessage, state] = useCreateMessageMutation();
  const [error, setError] = useState<string>();
  return (
    <CommentDialog
      open
      title="Add comment"
      description={target.label ? `Add a note to ${target.label}.` : "Add a note to this record."}
      submitLabel="Add comment"
      required
      colorScheme="inherit"
      isSubmitting={state.isLoading}
      error={error}
      onCancel={onClose}
      onSubmit={async (comment) => {
        if (!comment?.trim() || state.isLoading) return;
        setError(undefined);
        try {
          await createMessage({
            objectId: target.objectId,
            objectType: target.objectType,
            tenantCode: target.tenantCode,
            messageType: "Comment",
            message: comment,
            personId: auth?.userId,
          }).unwrap();
          onCreated?.();
          onClose();
        } catch {
          setError("The comment could not be added. Your draft is kept; please try again.");
        }
      }}
    />
  );
}
